
<div id="editors"> 

  

  @for (group of (activeEmployeeGroupes | TicketGroups); track group; let i = $index) {
    <div  style="z-index: 1;">
      <user-circle style="filter: brightness(0.7);" [id]="group?.id" [firstName]="group?.description" [indented]="true" [loadImage]="false"></user-circle>
    </div>
  }
  @for (editor of (activeEmployees | TicketEmployees); track editor; let i = $index) {
    <div  style="z-index: 2;">
      <user-circle [id]="editor?.id" [firstName]="editor?.firstName" [lastName]="editor?.lastName" [indented]="true"></user-circle>
    </div>
  }
  <div style="display: flex; margin-left: 10px;">
    @for (group of (activeObserverEmployeeGroupes | TicketGroups); track group; let i = $index) {
      <div style="z-index: 1;">
        <user-circle style="filter: brightness(0.7);" [id]="group?.id" [firstName]="group?.description" [indented]="true" [loadImage]="false"></user-circle>
      </div>
    }
    @for (editor of (activeObserverEmployee | TicketEmployees); track editor; let i = $index) {
      <div  style="z-index: 2;">
        <user-circle [id]="editor?.id" [firstName]="editor?.firstName" [lastName]="editor?.lastName" [indented]="true"></user-circle>
      </div>
    }
  </div>
  <div id="addEmployee" class="user-circle" (click)="addEmployee.emit()" style="z-index: 3;">
    <ion-icon name="fa-pen"></ion-icon>
  </div>
</div>